import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDisabled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#949ba7",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0.375C10.0161 0.375 11.9492 1.17398 13.3779 2.5957C13.3824 2.59995 13.3882 2.60302 13.3926 2.60742C13.3967 2.61151 13.3994 2.61692 13.4033 2.62109C14.8257 4.04988 15.625 5.98348 15.625 8C15.625 10.0223 14.8216 11.9616 13.3916 13.3916C11.9616 14.8216 10.0223 15.625 8 15.625C5.97772 15.625 4.03836 14.8216 2.6084 13.3916C1.17843 11.9616 0.375 10.0223 0.375 8C0.375 5.97772 1.17843 4.03836 2.6084 2.6084C4.03836 1.17843 5.97772 0.375 8 0.375ZM3.95605 12.9277C5.0911 13.8593 6.51886 14.375 8 14.375C9.69076 14.375 11.3123 13.7034 12.5078 12.5078C13.7034 11.3123 14.375 9.69076 14.375 8C14.375 6.51886 13.8593 5.0911 12.9277 3.95605L3.95605 12.9277ZM8 1.625C6.30924 1.625 4.68773 2.29664 3.49219 3.49219C2.29664 4.68773 1.625 6.30924 1.625 8C1.625 9.48093 2.14 10.909 3.07129 12.0439L12.0439 3.07129C10.909 2.14 9.48093 1.625 8 1.625Z",
		fill: "currentColor"
	})
});
export default SvgDisabled;
